import { useLocation } from 'react-router-dom';

export default function ReturnAfterDocuSignPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const event = searchParams.get('event');
  const isSuccess = event === 'signing_complete';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div
        className={`bg-white rounded-2xl shadow-lg p-8 max-w-md text-center ${
          isSuccess ? 'border-green-500' : 'border-yellow-500'
        } border-t-4`}
      >
        <div
          className={`flex items-center justify-center w-20 h-20 rounded-full mx-auto mb-6 ${
            isSuccess ? 'bg-green-100' : 'bg-yellow-100'
          }`}
        >
          {isSuccess ? (
            <svg
              className="w-10 h-10 text-green-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          ) : (
            <svg
              className="w-10 h-10 text-yellow-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M12 17a5 5 0 100-10 5 5 0 000 10z" />
            </svg>
          )}
        </div>

        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          {isSuccess ? 'Sikeres aláírás!' : 'Sikertelen vagy megszakított aláírás'}
        </h1>
        <p className="text-gray-600 mb-6">
          {isSuccess
            ? 'A szerződést sikeresen aláírtad. Köszönjük a közreműködésed!'
            : 'Valamiért nem sikerült az aláírás. Kérlek próbáld meg újra.'}
        </p>
        <a
          href="/"
          className="inline-block bg-blue-600 text-white px-6 py-2 rounded-xl font-medium hover:bg-blue-700 transition"
        >
          Vissza a főoldalra
        </a>
      </div>
    </div>
  );
}

  